module.exports = __webpack_public_path__ + "img/close.2c02013c.svg";